export const workTimeline = [
  { company: "Retainly", role: "Product Owner & Founding Engineer" },
  { company: "Ace Beverage Group", role: "Sales Representative" },
  { company: "Johnson Controls", role: "Automation Engineer Intern" },
  { company: "Snappy Innovations", role: "Software Developer & Business Analyst Intern" },
  { company: "Synapsis Biohackathon", role: "Lead Events Coordinator" },
  { company: "Queen's Startup Summit", role: "Venture Capital Pitch 2nd Place" },
  { company: "Queen's University", role: "Private Tutor & Teaching Assistant" },
  { company: "EF Tours", role: "Ecuador Service Project Volunteer" },
  { company: "Kumon", role: "Kumon Assistant" },
  { company: "Sansotei Ramen", role: "Line Cook" },
  { company: "City of Richmond Hill", role: "QA and Project Management Intern" },
];



